import React from "react";
import { CAUSES } from "../lib/site";

export default function Causes() {
  return (
    <section
      id="causes"
      data-testid="causes-section"
      className="relative py-20 sm:py-32 bg-white"
    >
      <div className="absolute inset-0 islamic-pattern opacity-60 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-12 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 sm:mb-16">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.24em] font-semibold text-[#064E3B]">
              Our Causes
            </div>
            <div className="pill-divider mt-4" />
            <h2 className="font-serif-display text-3xl sm:text-5xl mt-6 leading-[1.1] text-[#111827] font-semibold">
              Channels of giving,{" "}
              <span className="italic text-[#064E3B]">avenues of mercy.</span>
            </h2>
          </div>
          <p className="text-[#374151] text-sm sm:text-base lg:max-w-md leading-relaxed">
            Through fard (obligatory) and nafl (voluntary) charity, every gift becomes
            a direct line of support to a family in need.
          </p>
        </div>

        {/* Bento asymmetric grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 sm:gap-5">
          {/* Card 1 — large */}
          <CauseCard cause={CAUSES[0]} span="md:col-span-4 md:row-span-2" tall />
          <CauseCard cause={CAUSES[1]} span="md:col-span-2" />
          <CauseCard cause={CAUSES[2]} span="md:col-span-2" />
          {/* Card 4 — large */}
          <CauseCard cause={CAUSES[3]} span="md:col-span-6" wide />
        </div>
      </div>
    </section>
  );
}

function CauseCard({ cause, span, tall, wide }) {
  return (
    <article
      data-testid={`cause-${cause.title.toLowerCase().replace(/\s+/g, "-")}`}
      className={`group relative overflow-hidden rounded-3xl border border-[#E5E0DA] bg-[#FAF5F0] transition-all hover:-translate-y-1 hover:shadow-xl ${span} ${
        tall ? "min-h-[340px] sm:min-h-[420px]" : "min-h-[220px] sm:min-h-[260px]"
      } ${wide ? "min-h-[220px] sm:min-h-[260px]" : ""}`}
    >
      <div className="absolute inset-0">
        <img
          src={cause.img}
          alt={cause.title}
          className="h-full w-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b1f17]/95 via-[#0b1f17]/40 to-transparent" />
      </div>

      <div className="relative h-full p-6 sm:p-8 flex flex-col justify-end text-white">
        <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#FCD34D] mb-2">
          {cause.arabic}
        </div>
        <h3 className="font-serif-display text-2xl sm:text-4xl font-semibold leading-tight">
          {cause.title}
        </h3>
        <p className="mt-2 sm:mt-3 text-white/85 max-w-xl text-sm sm:text-base leading-relaxed">
          {cause.description}
        </p>
      </div>
    </article>
  );
}
